import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      currency: '€',
      withVat: '€ incl. VAT',
    },
    fr: {
      currency: '€',
      withVat: '€ TTC',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
